<script lang="ts" setup>
import { RenderPageHeaderActions } from '#layers/chrome/components/page-slot-provider';
import { usePaneStore } from '#layers/chrome/stores/pane';
import ProjectChromeHeaderPanelToggles from './ProjectChromeHeaderPanelToggles.vue';
import ProjectChromeHeaderSeparator from './ProjectChromeHeaderSeparator.vue';
import ProjectChromeProjectName from './ProjectChromeProjectName.vue';
import ProjectChromeSidebarToggle from './ProjectChromeSidebarToggle.vue';

const paneStore = usePaneStore();
</script>

<template>
	<header
		class="
			@container flex w-full items-center justify-between px-page ps-2.5 transition-[padding]
			block-(--primary-header-height)
		"
		:class="{
			'ps-2 sm:ps-3': paneStore.sidebarSplitPanelCollapsed,
			'relative before:absolute before:inset-s-0 before:border-s before:border-accented before:block-5': !paneStore.sidebarSplitPanelCollapsed,
		}"
	>
		<div class="flex min-w-0 flex-1 items-center overflow-hidden">
			<ProjectChromeSidebarToggle v-if="paneStore.sidebarSplitPanelCollapsed" />

			<template v-if="paneStore.sidebarSplitPanelCollapsed">
				<ProjectChromeProjectName />
				<ProjectChromeHeaderSeparator />
			</template>

			<slot />

			<div class="flex flex-1 items-center gap-2 overflow-hidden">
				<RenderPageHeaderActions />
			</div>
		</div>

		<ProjectChromeHeaderPanelToggles />
	</header>
</template>
